import i18n from './config';
import { detectLanguageByIP } from './ipDetection';

// Trigger lightweight IP detection for visitors (reacts to VPN location)
detectLanguageByIP();

export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, DEFAULT_NAMESPACE, NAMESPACES } from './languages';
export { default as useLanguage } from './useLanguage';
export { detectLanguageByIP } from './ipDetection';
export default i18n;
